import { Controller } from "@hotwired/stimulus"
// Vendored, imported by relative path so importmap and esbuild hosts both
// load it without npm. Its name ends in .digested.js so Propshaft serves it
// at that name rather than fingerprinting it.
import Cropper from "../vendor/cropper-1_6_2_esm.digested.js"

// Frames the chosen JPEG or GIF with Cropper.js, locked to the placement's ratio,
// and writes the box in the image's own pixels, as the browser shows it
// (after EXIF rotation, which is how the server crops), to the hidden
// crop[x], crop[y], crop[width] and crop[height] fields.
export default class extends Controller {
  static targets = [ "file", "image", "x", "y", "width", "height" ]
  static values = { ratio: Number }

  disconnect() {
    this.destroy()
  }

  load() {
    this.destroy()
    const file = this.fileTarget.files[0]
    if (!file) return

    this.url = URL.createObjectURL(file)
    this.imageTarget.src = this.url
    this.imageTarget.hidden = false
    this.cropper = new Cropper(this.imageTarget, {
      aspectRatio: this.ratioValue,
      viewMode: 1,
      autoCropArea: 1,
      checkOrientation: false,
      rotatable: false,
      scalable: false,
      zoomable: false,
      ready: () => this.write(),
      crop: () => this.write()
    })
  }

  write() {
    if (!this.cropper) return

    const { x, y, width, height } = this.cropper.getData(true)
    this.xTarget.value = x
    this.yTarget.value = y
    this.widthTarget.value = width
    this.heightTarget.value = height
  }

  destroy() {
    this.cropper?.destroy()
    this.cropper = null
    if (this.url) URL.revokeObjectURL(this.url)
    this.url = null
  }
}
